import React, { useState } from 'react'
import MakeDownloadblePdf from './MakeDownloadblePdf'
import QcrLoader from 'Components/Icons/QcrLoader';

function DownloadDetailsOnProfContent({caseDetails,  isResponseReceived, onDownload, downloadButtonRef}) {
  return (
    <>
        <div 
        className={'cursor-pointer  text-xs  mt-4 font-bold text-gray-800' + ((isResponseReceived === null || isResponseReceived === false) ? ' underline' : ' text-indigo-600')}
        onClick={()=>{ return ((isResponseReceived === null || isResponseReceived === false) ? onDownload(false) : '')
        }}
        >
          {isResponseReceived !== null  ? (isResponseReceived === true  ?<span className='flex'> 
            <div className=''>
                        <QcrLoader variant="draw" size="sm" />
                        </div>
                        &nbsp; Please wait while we prepare the files, zip and download...
           </span>: "Download complete case details") : "Download complete case details"}
         </div>

        <MakeDownloadblePdf
        caseDetails={caseDetails} 
        content={<div className="hidden" id="hiddenDiv" ref={downloadButtonRef}>
        complete</div>}
        />
    </>
  )
}

export default DownloadDetailsOnProfContent